<div  class="dialog-title">Edit {{ data.entityName }} Mappings</div>
<div class="dialog-content">
  <div style="padding-top: 8px; display: flex; flex-direction: column; gap: 16px;">
    <p>Assign items for <strong>{{ data.entityLabel }}</strong>.</p>
    
    <app-form-input label="Search items..." style="width: 100%;" [(ngModel)]="searchQuery" placeholder="Type to search..."></app-form-input>

    <div style="max-height: 400px; overflow-y: auto; border: 1px solid #eee; border-radius: 4px; padding: 8px;">
      <div *ngIf="filteredItems.length === 0" style="padding: 16px; text-align: center; color: #666;">
        No items found.
      </div>
      
      <div *ngFor="let item of filteredItems" style="padding: 4px 8px; cursor: pointer;" (click)="toggleSelection(data.getItemId(item))">
        <app-checkbox style="pointer-events: none;" [checked]="selectedIds.has(data.getItemId(item))">
          {{ data.getItemLabel(item) }}
        </app-checkbox>
      </div>
    </div>
  </div>
</div>
<div class="dialog-actions">
  <button (click)="dialogRef.close()" class="btn btn-text">Cancel</button>
  <button  (click)="onSave()" class="btn btn-primary">Save Changes</button>
</div>
